import { render, staticRenderFns } from "./siderPaypal.vue?vue&type=template&id=25a3cb48&scoped=true&"
import script from "./siderPaypal.vue?vue&type=script&lang=js&"
export * from "./siderPaypal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a3cb48",
  null
  
)

export default component.exports